import {useEffect, useState, useRef} from "react";
import httpService from "../../services/httpService";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import { FaRegCircleCheck } from "react-icons/fa6";
import { FaSpinner } from "react-icons/fa6";
import { FaPlay, FaPause } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import AudioPlayer from "../AudioPlayer";
import LoadingFade from "../LoadingFade";
import InsightItem from "../clubWizard/InsightItem";
import Form from "react-bootstrap/Form";
import Collapse from "react-bootstrap/Collapse";
import Accordion from "react-bootstrap/Accordion";
import NewInsightItem from "../clubWizard/NewInsightItem";
const EpisodeTakeawaysData = ({ episode }) => {
    const [epi, setEpi] = useState({});
    const [insights, setInsights] = useState([]);
    const [loading, setLoading] = useState(true);
    const [insightsLoading, setInsightsLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [startAudio, setStartAudio] = useState('00:00');
    const [errorMessage, setErrorMessage] = useState('');
    const [activeKey, setActiveKey] = useState(0);
    const [useInProcessing, setUseInProcessing] = useState(true);
    const [showCustomInsight, setShowCustomInsight] = useState(false);
    const [showDescription, setShowDescription] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const [showAudioControl, setShowAudioControl] = useState(false);
    const audioRef = useRef(null);

    useEffect(() => {
        // Show audio control button after 1.5 seconds with fade-in
        const timer = setTimeout(() => {
            setShowAudioControl(true);
        }, 1500);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        setLoading(true);
        const payload = {}
        httpService.get("/dash/wizard/get-podcast-club-episode/"+episode.pivot.podcast_club_id+"/"+episode.pivot.podcast_episode_id)
            .then((res) => {
                setEpi({...res.data.episode})
                setInsights(res.data.insights)
            })
            .catch((err) => {
                setErrorMessage(err.response?.data?.message || "Error loading data");
            }).finally(() => {
            setLoading(false);
        });
    }, [episode]);

    // const handleSaveEpisode = async (episode) => {
    //     setSaving(true)
    //     try {
    //         const res = await httpService.post("dash/wizard/save-episode",episode);
    //         if(res.data.status === 'created'){
    //             setEpi({...epi, saved:true})
    //             onEpisodeSaved()
    //         }
    //     } catch (err) {
    //         setErrorMessage(err.message)
    //     } finally {
    //         setSaving(false)
    //     }
    // }

    const generateInsights = async () => {
        setInsightsLoading(true);
        httpService.get("/dash/wizard/podcast-club-episode-generate-insights/"+episode.pivot.podcast_club_id+"/"+episode.pivot.podcast_episode_id+"/"+(useInProcessing ? 1 : 0))
            .then((res) => {
                setInsights(res.data.insights)
            })
            .catch((err) => {
                setErrorMessage(err.response?.data?.message || "Error loading data");
            }).finally(() => {
            setInsightsLoading(false);
        });
    }

    const getInsights = () => {
        httpService.get("/dash/wizard/podcast-club-episode-get-insights/"+episode.pivot.podcast_club_id+"/"+episode.pivot.podcast_episode_id)
            .then((res) => {
                setInsights(res.data.insights)
            })
            .catch((err) => {
                setErrorMessage(err.response?.data?.message || "Error loading data");
            }).finally(() => {
            setLoading(false);
        });
    }

    const playFrom = (start) => {
        if (audioRef.current) {
            // Convert time to seconds if needed
            let seconds = start;
            if (typeof start === 'string' && start.includes(':')) {
                const parts = start.split(':').map(Number);
                if (parts.length === 3) {
                    seconds = parts[0] * 3600 + parts[1] * 60 + parts[2];
                } else if (parts.length === 2) {
                    seconds = parts[0] * 60 + parts[1];
                }
            }
            audioRef.current.currentTime = seconds;
            audioRef.current.play();
        }
    }

    const togglePlayPause = () => {
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause();
            } else {
                audioRef.current.play();
            }
        }
    };

    const closeItem = (idx) => {
        console.log('close item')
        if (activeKey === String(idx)) setActiveKey(null);
    };

    const handleUseInProcessingChange = (e) => {
        setUseInProcessing(e.target.checked)
    }

    return(
        <div className={'component-EpisodeTakeawaysData'}>
            <LoadingFade loading={loading} stateKey={loading?'loading':'not-loading'}>
                <Image fluid src={'/img/console-wide.jpg'} className="mb-3 fluid" />
                <Row className={'mb-3'}>
                    <Col sm={10}>
                        <h4>{epi.title}</h4>
                    </Col>
                    <Col sm={2} className={'text-center'}>
                        <Image
                            src={epi.featured_image}
                            alt={epi.title}
                            width={48}
                            height={48}
                            style={{ objectFit: "cover", borderRadius: 8 }}
                            loading="lazy"
                        />
                    </Col>
                </Row>
                <Row className={'mb-3'}>
                    <Col sm={12} className={'component-EpisodeTakeawaysData-AudioPlayer-wrapper'}>
                        {/*<AudioPlayer*/}
                        {/*    src={epi.audio_url}*/}
                        {/*    startAt={startAudio}     // or 312.5*/}
                        {/*    autoPlay={false}*/}
                        {/*    playbackRate={1.0}*/}
                        {/*    onReady={(audio) => {*/}
                        {/*        audioRef.current = audio;*/}
                        {/*        audio.addEventListener('play', () => setIsPlaying(true));*/}
                        {/*        audio.addEventListener('pause', () => setIsPlaying(false));*/}
                        {/*    }}*/}
                        {/*    id={'EpisodeTakeawaysData-AudioPlayer'}*/}
                        {/*    className={'component-EpisodeTakeawaysData-AudioPlayer'}*/}
                        {/*    // chapters={[*/}
                        {/*    //     { label: "Intro", at: "0:00" },*/}
                        {/*    //     { label: "Guest joins", at: "5:12" },*/}
                        {/*    //     { label: "Key idea", at: 1086 }, // seconds*/}
                        {/*    // ]}*/}
                        {/*/>*/}
                    </Col>
                </Row>

                <Row className={'mb-3'}>
                    <Col sm={6}>
                        <Button disabled={insightsLoading} onClick={generateInsights} className="w-100" variant="primary">
                            {insightsLoading ? <FaSpinner className={"loading_spinner"} /> : 'Create Insights with AI'}
                        </Button>
                    </Col>
                    <Col sm={6}>
                        <Button disabled={insightsLoading} onClick={() => setShowCustomInsight(!showCustomInsight)} className="w-100" variant="primary">
                            Create insight ( manual )
                        </Button>
                    </Col>
                    <Col sm={12}>
                        <Collapse in={showCustomInsight} className={'mt-3'}>
                            <div id="" className="w-100 m-0">
                                <NewInsightItem
                                    podcast_episode_id={episode.pivot.podcast_episode_id}
                                    podcast_club_id={episode.pivot.podcast_club_id}
                                    onClose={setShowCustomInsight}
                                    onInsightSaved={getInsights}/>
                            </div>
                        </Collapse>
                    </Col>
                </Row>
                {insights.length ?
                    <Row className={'mb-3'}>
                        <Col>
                            <Accordion activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
                                {insights.map((insight, index) => (
                                    <Accordion.Item key={insight.id} eventKey={String(index)}>
                                        <Accordion.Header>{insight.title}</Accordion.Header>
                                        <Accordion.Body>
                                            <InsightItem
                                                onInsightDeleted={() => closeItem(index)}
                                                insight={insight}
                                                onInsightSaved={getInsights}
                                                audioUrl={epi.audio_url}
                                                episode={episode}
                                            />
                                        </Accordion.Body>
                                    </Accordion.Item>
                                ))}
                            </Accordion>
                        </Col>
                    </Row>
                    :
                    ""
                }
                <Row>
                    <Col sm={12}>
                        <Button
                            onClick={() => setShowDescription(!showDescription)}
                            aria-controls="episode-description-collapse"
                            aria-expanded={showDescription}
                            variant="primary"
                            className="mb-2 w-100"
                        >
                            {showDescription ? 'Hide' : 'Read'} Description
                        </Button>
                        <Collapse in={showDescription}>
                            <div id="episode-description-collapse">
                                <div dangerouslySetInnerHTML={{__html: epi.description}}></div>
                            </div>
                        </Collapse>
                    </Col>
                </Row>
            </LoadingFade>

            {epi?.audio_url && showAudioControl && (
                <div
                    className="audio-control-fixed"
                    style={{
                        animation: 'fadeIn 0.5s ease-in',
                        opacity: 1
                    }}
                >
                    {/*<Button*/}
                    {/*    variant="primary"*/}
                    {/*    className="rounded-circle"*/}
                    {/*    onClick={togglePlayPause}*/}
                    {/*    style={{ width: '50px', height: '50px' }}*/}
                    {/*>*/}
                    {/*    {isPlaying ? <FaPause /> : <FaPlay />}*/}
                    {/*</Button>*/}
                </div>
            )}
        </div>
    )
}

export default EpisodeTakeawaysData;